import Cookies from 'js-cookie'

/*
 * Extract UTM attribution parameters from their locally stored place (cookies)
 */
const getUtmAttributionParams = () => {
    const utmCampaign = Cookies.get('utm_campaign')
    const utmMedium = Cookies.get('utm_medium')
    const utmSource = Cookies.get('utm_source')
    return { utmCampaign, utmMedium, utmSource }
}

export default getUtmAttributionParams
